import { IoCheckmarkCircleOutline } from "react-icons/io5"
import { BiCoinStack } from "react-icons/bi"
import { MdOutlineCloudUpload } from 'react-icons/md'; // Cloud-Based Model Deployment
import { MdOutlineDevices } from 'react-icons/md'; 
import img1 from "../../../assets/img/EngineeringExcellence/Ip/Framework.png"
import { AiOutlineLock } from 'react-icons/ai';
import { FaTruck } from 'react-icons/fa';
import { FaFileContract } from 'react-icons/fa';

import { IoIosCheckmarkCircleOutline } from "react-icons/io";

export default function MainSection4() { 
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Proprietary Frameworks and Platforms
            </h1>
            <p className="text-lg text-gray-600">
            These and other IPs position AeroAegis as a trusted partner for businesses seeking tailored and scalable solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoIosCheckmarkCircleOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Maturity Spectrum 360</h3>
              </div>
              <p className="text-gray-600 text-sm">
              Our proprietary framework for assessing digital transformation maturity and guiding organizations toward achieving excellence in technology adoption.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoIosCheckmarkCircleOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">SmartChaos Lab</h3>
              </div>
              <p className="text-gray-600 text-sm">
              A unique platform for chaos engineering, enabling businesses to test resilience and optimize operational stability in dynamic environments.
              </p>
            </div>
{/* Feature 3 */}
{/* <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaFileContract className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Smart Contracts</h3>
              </div>
              <p className="text-gray-600 text-sm">
              These and other IPs position AeroAegis as a trusted partner for businesses seeking tailored and scalable solutions.

              </p>
            </div> */}
      
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  )
}